<template>

  <div class="product-list">
    <CCard>
      <CCardHeader>
        <strong>
          گزارش سئو
        </strong>

      </CCardHeader>

      <CCardBody class="">
        <CTabs>
          <CTab title="آمار بازدید محصولات">

            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped
                sorter
                column-filter
                :pagination="true"
                :items-per-page="100"
                :items="product_views_list"
                :fields="product_views_list_fields"
                head-color="light"
            >
              <template #row_id="{item,index}">
                <td>
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #change_day="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_day>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_day }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_day) }}
                  </p>
                </td>
              </template>
              <template #change_month="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_month>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_month }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_month) }}
                  </p>
                </td>
              </template>


              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goOrderInfo(item)"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>

                </td>
              </template>

            </CDataTableFixed>

          </CTab>
          <CTab title="آمار بازدید مقالات">
            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped
                sorter
                column-filter
                :pagination="true"
                :items-per-page="100"
                :items="post_views_list"
                :fields="product_views_list_fields"
                head-color="light"
            >
              <template #row_id="{item,index}">
                <td>
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #change_day="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_day>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_day }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_day) }}
                  </p>
                </td>
              </template>
              <template #change_month="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_month>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_month }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_month) }}
                  </p>
                </td>
              </template>


              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goOrderInfo(item)"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>

                </td>
              </template>

            </CDataTableFixed>
          </CTab>
          <CTab title="آمار بازدید روزانه">
            <CRow>
              <CCol>
                <CDataTableFixed
                    class="mb-0 table-outline"
                    hover
                    striped
                    sorter
                    column-filter
                    :pagination="true"
                    :items-per-page="100"
                    :items="product_views_perday"
                    :fields="product_views_perday_fields"
                    head-color="light"
                >
                  <template #row_id="{item,index}">
                    <td>
                      <p>{{ index + 1 }}</p>
                    </td>
                  </template>
                  <template #operation="{item,index}">
                    <td class="py-2">
                      <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          @click="goOrderInfo(item)"
                      >
                        <CIcon name="eye" size="sm"/>
                      </CButton>

                    </td>
                  </template>

                </CDataTableFixed>
              </CCol>
              <CCol>
                <CDataTableFixed
                    class="mb-0 table-outline"
                    hover
                    striped
                    sorter
                    column-filter
                    :pagination="true"
                    :items-per-page="100"
                    :items="post_views_perday"
                    :fields="product_views_perday_fields"
                    head-color="light"
                >
                  <template #row_id="{item,index}">
                    <td>
                      <p>{{ index + 1 }}</p>
                    </td>
                  </template>
                  <template #operation="{item,index}">
                    <td class="py-2">
                      <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          @click="goOrderInfo(item)"
                      >
                        <CIcon name="eye" size="sm"/>
                      </CButton>

                    </td>
                  </template>

                </CDataTableFixed>

              </CCol>
            </CRow>
          </CTab>
          <CTab title="آمار فراوانی محصولات">
            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped
                sorter
                column-filter
                :pagination="true"
                :items-per-page="100"
                :items="product_faravani"
                :fields="product_faravani_fields"
                head-color="light"
            >
              <template #row_id="{item,index}">
                <td>
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goOrderInfo(item)"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>

                </td>
              </template>

            </CDataTableFixed>
          </CTab>
          <CTab title="رتبه بندی سئو مقالات">
            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped
                sorter
                column-filter
                :pagination="true"
                :items-per-page="100"
                :items="blog_posts"
                :fields="blog_posts_fields"
                head-color="light"
            >
              <template #row_id="{item,index}">
                <td>
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #seoScore="{item}">
                <td>
                  <p class="text-success" v-if="item.seoScore>65">{{ item.seoScore }}</p>
                  <p class="text-warning" v-if="item.seoScore<=65 && item.seoScore>=45 ">{{ item.seoScore }}</p>
                  <p class="text-danger" v-if="item.seoScore<45">{{ item.seoScore }}</p>
                </td>
              </template>
              <template #readabilityScore="{item}">
                <td>
                  <p class="text-success" v-if="item.readabilityScore>65">{{ item.readabilityScore }}</p>
                  <p class="text-warning" v-if="item.readabilityScore<=65 && item.readabilityScore>=45 ">
                    {{ item.readabilityScore }}</p>
                  <p class="text-danger" v-if="item.readabilityScore<45">{{ item.readabilityScore }}</p>
                </td>
              </template>
              <template #wordCount="{item}">
                <td>
                  <p class="text-success" v-if="item.wordCount>1500">{{ item.wordCount }}</p>
                  <p class="text-warning" v-if="item.wordCount<=1500 && item.wordCount>=700 ">{{ item.wordCount }}</p>
                  <p class="text-danger" v-if="item.wordCount<700">{{ item.wordCount }}</p>
                </td>
              </template>
              <template #imageCount="{item}">
                <td>
                  <p class="text-success" v-if="item.imageCount>4">{{ item.imageCount }}</p>
                  <p class="text-warning" v-if="item.imageCount<=4 && item.imageCount>=1 ">{{ item.imageCount }}</p>
                  <p class="text-danger" v-if="item.imageCount<1">{{ item.imageCount }}</p>
                </td>
              </template>
              <template #linkCount="{item}">
                <td>
                  <p class="text-success" v-if="item.linkCount>4">{{ item.linkCount }}</p>
                  <p class="text-warning" v-if="item.linkCount<=4 && item.linkCount>=1 ">{{ item.linkCount }}</p>
                  <p class="text-danger" v-if="item.linkCount<1">{{ item.linkCount }}</p>
                </td>
              </template>

              <template #h1Count="{item}">
                <td>
                  <p class="text-success" v-if="item.h1Count==1">{{ item.h1Count }}</p>
                  <p class="text-danger" v-if="item.h1Count!=1">{{ item.h1Count }}</p>
                </td>
              </template>
              <template #hierarchy="{item}">
                <td>
                  <p class="text-success" v-if="item.hierarchy">صحیح</p>
                  <p class="text-danger" v-else>خطا</p>
                </td>
              </template>
              <template #h2Count="{item}">
                <td>
                  <p class="text-success" v-if="item.h2Count>4">{{ item.h2Count }}</p>
                  <p class="text-warning" v-if="item.h2Count<=4 && item.h2Count>=1 ">{{ item.h2Count }}</p>
                  <p class="text-danger" v-if="item.h2Count<1">{{ item.h2Count }}</p>
                </td>
              </template>


              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="warning"
                      variant="outline"
                      square
                      size="sm"
                      @click="show_info_seo_modal(item)">
                    <CIcon name="cil-info"/>
                  </CButton>
                  <CButton
                      color="success"
                      variant="outline"
                      square
                      size="sm"
                      @click="show_blog_post(item)"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>
                  <CButton
                      color="warning"
                      variant="outline"
                      square
                      size="sm"
                      @click="edit_blog_post(item)"
                  >
                    <CIcon name="cil-pencil" size="sm"/>
                  </CButton>

                </td>
              </template>

            </CDataTableFixed>
          </CTab>
          <CTab title="گزارش لینک سازی">
<LinkAnalysis :items="link_analyse_items" />
          </CTab>

        </CTabs>
      </CCardBody>
    </CCard>

    <CModal :show.sync="seo_state_modal" title="اطلاعات سئو">
      <div v-if="result_seo" class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- رتبه‌ها -->

        <!-- جزئیات -->
        <div class="  rounded">
          <h2 class="text-xl font-semibold mb-2">جزئیات</h2>
          <p>متا توضیحات: {{ result_seo.details.hasMetaDescription ? 'دارد' : 'ندارد' }}</p>
          <p v-if="result_seo.details.hasMetaDescription">طول متا: {{ result_seo.details.metaDescriptionLength }}
            کاراکتر</p>
          <p>کلمه کلیدی در H1: {{ result_seo.details.keywordInH1 ? 'دارد' : 'ندارد' }}</p>
          <p>کلمه کلیدی در متا: {{ result_seo.details.keywordInMeta ? 'دارد' : 'ندارد' }}</p>
        </div>

        <!-- پیام‌ها -->
        <div class="  rounded">
          <h2 class="text-xl font-semibold mb-2">پیام‌ها</h2>
          <div v-if="result_seo.errors.length">
            <h3 class="text-red-600">خطاها:</h3>
            <ul class="list-disc pl-5">
              <li v-for="error in result_seo.errors" :key="error" class="text-red-600">{{ error }}</li>
            </ul>
          </div>
          <div v-if="result_seo.warnings.length">
            <h3 class="text-yellow-600">هشدارها:</h3>
            <ul class="list-disc pl-5">
              <li v-for="warning in result_seo.warnings" :key="warning" class="text-yellow-600">{{ warning }}</li>
            </ul>
          </div>
          <div v-if="result_seo.successes.length">
            <h3 class="text-green-600">موفقیت‌ها:</h3>
            <ul class="list-disc pl-5">
              <li v-for="success in result_seo.successes" :key="success" class="text-green-600">{{ success }}</li>
            </ul>
          </div>
        </div>
      </div>
    </CModal>
  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../main";
import {CChartLineSimple} from "@/views/charts";
import {parser_config_in_site, custom_parser_config_in_site} from "@/plugins/editorjs_config";
import LinkAnalysis from "./LinkAnalyseComponent.vue";

export default {
  name: 'Login',
  components: {
    LinkAnalysis,
    CChartLineSimple
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {
      seo_state_modal: false,
      result_seo: null,
      product_views_list: [],
      post_views_list: [],
      product_views_list_fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'عنوان'},
        {key: 'views_last_7_days', label: 'بازدید 7 روز گذشته', _classes: 'text-center'},
        {key: 'views_7_to_14_days', label: 'بازدید 14 روز گذشته', _classes: 'text-center'},
        {key: 'change_day', label: 'تغییر', _classes: 'text-center'},
        {key: 'views_last_month', label: 'بازدید 1 ماه گذشته', _classes: 'text-center'},
        {key: 'views_1_to_2_months', label: 'بازدید 2 ماه گذشته', _classes: 'text-center'},
        {key: 'change_month', label: 'تغییر', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],

      product_views_perday: [],
      post_views_perday: [],

      product_views_perday_fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'عنوان'},
        {key: 'total_views', label: 'بازدید کل', _classes: 'text-center'},
        {key: 'views_per_day', label: 'بازدید / روز', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      product_faravani: [],
      product_faravani_fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'عنوان'},
        {key: 'usage_count', label: 'تعداد استفاده شده', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      blog_posts: [],
      blog_posts_fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'عنوان'},
        {key: 'keyword', label: 'کلمه کلیدی'},
        {key: 'seoScore', label: 'سئو', _classes: 'text-center'},
        {key: 'readabilityScore', label: 'خوانایی', _classes: 'text-center'},
        {key: 'wordCount', label: 'کلمات', _classes: 'text-center'},
        {key: 'imageCount', label: 'تصاویر', _classes: 'text-center'},
        {key: 'linkCount', label: 'لینک', _classes: 'text-center'},
        {key: 'h1Count', label: 'H1', _classes: 'text-center'},
        {key: 'h2Count', label: 'H2', _classes: 'text-center'},
        {key: 'hierarchy', label: 'ترتیب هدینگ', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],

      products: [],
      link_analyse_items: [],
      parser: null,

    }
  },
  mounted() {
    this.parser = new edjsParser(parser_config_in_site, custom_parser_config_in_site, {});

    this.get_view_list_data();
    this.get_view_list_perday();
    this.get_products_faravani();
    this.get_blogs_seo();

  },
  watch: {},
  methods: {
    show_blog_post(item) {
      window.open(localStorage.getItem("web_address") + "blog/" + item.slug, "_blank");

    },
    edit_blog_post(item) {
      this.$router.push({path: '/dashboard/news/edit-news/' + item.source})
    },
    get_view_list_data() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_view_list_data', form_data, {}).then(function (response) {
        response.data.products.forEach(function (val) {
          val.change_day = self.calculatePercentageChange(val.views_last_7_days, val.views_7_to_14_days)
          val.change_month = self.calculatePercentageChange(val.views_last_month, val.views_1_to_2_months)
        })
        response.data.posts.forEach(function (val) {
          val.change_day = self.calculatePercentageChange(val.views_last_7_days, val.views_7_to_14_days)
          val.change_month = self.calculatePercentageChange(val.views_last_month, val.views_1_to_2_months)
        })
        self.product_views_list = response.data.products
        self.post_views_list = response.data.posts

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_view_list_perday() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_view_list_perday', form_data, {}).then(function (response) {


        self.product_views_perday = response.data.products
        self.post_views_perday = response.data.posts

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_products_faravani() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_products_faravani', form_data, {}).then(function (response) {


        self.product_faravani = response.data.products

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_blogs_seo() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_blogs_seo', form_data, {}).then(function (response) {
        response.data.posts.forEach(function (val) {
          self.link_analyse_items.push(
              {
                type: 'article', // یا 'product'
                htmlContent: self.parser.parse(JSON.parse(val.description)),
                keyword: val.keyword,
                title: val.title,
                url: '/blog/' + val.slug // یا '/product/sample-product'
              }
          )
          val.seo_state = self.analyzeSEO(
              self.parser.parse(JSON.parse(val.description)),
              val.keyword,
              val.short_description,
              val.title)
          // console.log('val.seo_stats',val.seo_stats)
          val.seoScore = val.seo_state.seoScore
          val.readabilityScore = val.seo_state.readabilityScore
          val.wordCount = val.seo_state.stats.wordCount
          val.imageCount = val.seo_state.stats.imageCount
          val.linkCount = val.seo_state.stats.linkCount
          val.h1Count = val.seo_state.stats.h1Count
          val.h2Count = val.seo_state.stats.h2Count
          val.hierarchy = val.seo_state.stats.hierarchy
        })
        self.blog_posts = response.data.posts

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    show_info_seo_modal(item) {
      this.result_seo = item.seo_state
      this.seo_state_modal = true
    },
    calculatePercentageChange(viewsLast7Days, views7To14Days) {
      // چک کردن اینکه مقدار قدیم صفر نباشد (برای جلوگیری از تقسیم بر صفر)
      if (views7To14Days == 0) {
        if (viewsLast7Days == 0) return 0; // اگر هر دو صفر باشند، تغییر 0%
        return viewsLast7Days > 0 ? 100 : -100; // اگر قدیم صفر و جدید مثبت/منفی باشد
      }

      // محاسبه درصد تغییر
      const change = ((viewsLast7Days - views7To14Days) / views7To14Days) * 100;

      // گرد کردن به 2 رقم اعشار
      return Number(change.toFixed(2));
    },
    analyzeSEO(htmlSample, focusKeyword = "", meta_description, title) {
      // تبدیل HTML به DOM
      const htmlString = `
<html>
<head>
    <meta name="description" content="${meta_description}">
</head>
<body>
    <h1>${title}</h1>
    ${htmlSample}
</body>
</html>
`;
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      // متغیرها برای محاسبه
      const result = {
        seoScore: 0,              // رتبه سئو (0-100)
        readabilityScore: 0,      // رتبه خوانایی (0-100)
        stats: {
          wordCount: 0,         // تعداد کلمات
          imageCount: 0,        // تعداد تصاویر
          linkCount: 0,         // تعداد لینک‌ها
          h1Count: 0,           // تعداد H1
          h2Count: 0,            // تعداد H2
          hierarchy: this.validateHeadingHierarchy(htmlString),            // تعداد H2
        },
        details: {
          hasMetaDescription: false,
          metaDescriptionLength: 0,
          keywordInH1: false,
          keywordInMeta: false
        },
        errors: [],               // خطاها
        warnings: [],             // هشدارها
        successes: []             // موارد موفق
      };

      // 1. محاسبه تعداد کلمات و خوانایی
      const bodyText = doc.body.innerText || "";
      const words = bodyText.split(/\s+/).filter(word => word.length > 0);
      result.stats.wordCount = words.length;

      // خوانایی: ساده‌سازی شده بر اساس طول محتوا و جملات
      const sentenceCount = bodyText.split(/[.!?]+/).filter(s => s.trim().length > 0).length;
      const avgWordsPerSentence = sentenceCount > 0 ? result.stats.wordCount / sentenceCount : 0;
      if (result.stats.wordCount >= 300 && avgWordsPerSentence <= 20) {
        result.readabilityScore = 80;
        result.successes.push("محتوا طول مناسب و خوانایی خوبی دارد");
      } else if (result.stats.wordCount >= 150) {
        result.readabilityScore = 50;
        result.warnings.push("طول محتوا یا خوانایی می‌تواند بهتر باشد");
      } else {
        result.readabilityScore = 20;
        result.errors.push("محتوا خیلی کوتاه است");
      }

      // 2. بررسی سرتیترها
      result.stats.h1Count = doc.getElementsByTagName("h1").length;
      result.stats.h2Count = doc.getElementsByTagName("h2").length;
      if (result.stats.h1Count === 1) {
        result.seoScore += 20;
        result.successes.push("یک H1 پیدا شد");
      } else if (result.stats.h1Count > 1) {
        result.warnings.push("بیش از یک H1 وجود دارد");
      } else {
        result.errors.push("هیچ H1 پیدا نشد");
      }
      if (result.stats.h2Count > 0) {
        result.seoScore += 10;
        result.successes.push(`${result.stats.h2Count} سرتیتر H2 پیدا شد`);
      }

      // 3. بررسی کلمه کلیدی در H1
      if (focusKeyword && result.stats.h1Count > 0) {
        const h1Text = doc.getElementsByTagName("h1")[0].innerText.toLowerCase();
        result.details.keywordInH1 = h1Text.includes(focusKeyword.toLowerCase());
        if (result.details.keywordInH1) {
          result.seoScore += 15;
          result.successes.push(`کلمه کلیدی "${focusKeyword}" در H1 پیدا شد`);
        } else {
          result.warnings.push(`کلمه کلیدی "${focusKeyword}" در H1 نیست`);
        }
      }

      // 4. بررسی متا توضیحات
      const metaDesc = doc.querySelector('meta[name="description"]');
      if (metaDesc) {
        result.details.hasMetaDescription = true;
        result.details.metaDescriptionLength = metaDesc.getAttribute("content").length;
        if (result.details.metaDescriptionLength >= 120 && result.details.metaDescriptionLength <= 160) {
          result.seoScore += 15;
          result.successes.push("طول متا توضیحات مناسب است");
        } else {
          result.warnings.push(`طول متا توضیحات (${result.details.metaDescriptionLength} کاراکتر) خارج از محدوده 120-160 است`);
        }
        if (focusKeyword && metaDesc.getAttribute("content").toLowerCase().includes(focusKeyword.toLowerCase())) {
          result.details.keywordInMeta = true;
          result.seoScore += 10;
          result.successes.push(`کلمه کلیدی "${focusKeyword}" در متا توضیحات پیدا شد`);
        }
      } else {
        result.errors.push("متا توضیحات وجود ندارد");
      }

      // 5. تعداد تصاویر
      result.stats.imageCount = doc.getElementsByTagName("img").length;
      if (result.stats.imageCount > 0) {
        result.seoScore += 10;
        result.successes.push(`${result.stats.imageCount} تصویر پیدا شد`);
        // بررسی alt تصاویر
        const imagesWithoutAlt = Array.from(doc.getElementsByTagName("img")).filter(img => !img.getAttribute("alt"));
        if (imagesWithoutAlt.length > 0) {
          result.warnings.push(`${imagesWithoutAlt.length} تصویر بدون تگ alt`);
        }
      } else {
        result.warnings.push("هیچ تصویری پیدا نشد");
      }

      // 6. تعداد لینک‌ها
      result.stats.linkCount = doc.getElementsByTagName("a").length;
      if (result.stats.linkCount > 0) {
        result.seoScore += 10;
        result.successes.push(`${result.stats.linkCount} لینک پیدا شد`);
      } else {
        result.warnings.push("هیچ لینکی پیدا نشد");
      }

      // محدود کردن امتیاز به 100
      result.seoScore = Math.min(result.seoScore, 100);

      return result;
    },
    validateHeadingHierarchy(html) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const headings = doc.querySelectorAll('h1, h2, h3, h4, h5, h6');

      let lastLevel = 0;
      let hasH1 = false;

      for (const heading of headings) {
        const currentLevel = parseInt(heading.tagName.substring(1));

        // بررسی وجود H1
        if (currentLevel === 1) {
          if (hasH1) {
            console.error('خطا: بیش از یک تگ H1 وجود دارد.');
            return false;
          }
          hasH1 = true;
        }

        // بررسی ترتیب منطقی
        if (currentLevel > lastLevel + 1) {
          console.error(`خطا: پرش غیرمنطقی از H${lastLevel} به H${currentLevel}.`);
          return false;
        }

        lastLevel = currentLevel;
      }

      if (!hasH1) {
        console.error('خطا: تگ H1 یافت نشد.');
        return false;
      }

      return true;
    }
  }
}


</script>
